'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var CheckmarkMIcon = require('@alfalab/icons-glyph/CheckmarkMIcon');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"checkmark":"select__checkmark_1uwt8","selected":"select__selected_1uwt8","displayIcon":"select__displayIcon_1uwt8","displayBadge":"select__displayBadge_1uwt8"};
require('./index.css')

var Checkmark = function (_a) {
    var _b;
    var selected = _a.selected, className = _a.className;
    return (React__default.default.createElement("div", { className: cn__default.default(styles.checkmark, className, (_b = {},
            _b[styles.selected] = selected,
            _b)) },
        React__default.default.createElement(CheckmarkMIcon.CheckmarkMIcon, { className: styles.displayIcon })));
};

exports.Checkmark = Checkmark;
